import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { Content } from "../Components/Content";
import IconIncorrect from "@common/images/incorrect-feedback-icon.svg";
import { Icon } from "../Components/Icon";
import { TooltipWrapper } from "../Components/TootipWrapper";

/**
 * ErrorTooltip:
 *   - Typically used to display error messages
 */
export function ErrorTooltip(props) {
  const { title, className } = props;
  return (
    <TooltipWrapper className={`${style.errorTooltip} ${className}`}>
      <Icon icon={IconIncorrect} />
      <Content text={title} />
    </TooltipWrapper>
  );
}

ErrorTooltip.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Title text
   */
  title: PropTypes.string,
};

ErrorTooltip.defaultProps = {
  title: "",
  className: "",
};
